import React, { Component } from "react";
import InputForm from "./InputForm";
import axios from "axios";


class MotivoVisitaFrame extends Component {
    state = {
        lista: [],
        codigo: {
            key: '0',
            label: '',
        },
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        if (this.state.codigo.key !== this.props.value.key) {
            this.setState({
                codigo: {
                    key: this.props.value.key,
                    label: '',
                },
            })
        }
    }

    componentDidMount() {
        this.getListaRegistros();
    }

    getListaRegistros = () => {
        this.setState({ lista: [] })
        axios.get('/atividades/motivosVisitaCadastro', {
            params: {
                tipo: this.props.tipo
            }
        }).then(response => {
            const { data } = response;
            const lista = data.map(regList => {
                return {
                    key: regList.amv_idf,
                    label: regList.amv_descricao,
                }
            });
            if ((this.props.descricaoPrimeiroItem) && (this.props.descricaoPrimeiroItem !== '')) {
                lista.unshift({ key: '0', label: this.props.descricaoPrimeiroItem });
            }
            this.setState({
                lista,
            })
        }).catch(error => {
            console.error(error.response);
        })
    };

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        this.setState({ [id]: value });
        const state = {};
        state[id] = value;
        this.props.onChange(state);
    };



    render() {
        const { label, id, width, disabled } = this.props;
        const { lista, codigo } = this.state;
        return (
            <span style={{}}>
                <span>{label}</span>
                <InputForm
                    type="select"
                    id={id}
                    ref={id}
                    value={codigo}
                    onChange={this.onChange}
                    data={lista}
                    validator={value => Boolean(value)}
                    showSearch
                    style={{ width: width }}
                    disabled={ disabled ? true : false }
                />
            </span>
        );
    }
}

export default MotivoVisitaFrame;



// WEBPACK FOOTER //
// ./src/components/MotivoVisitaFrame.js